import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
// import ecprimeLogo from '../atoms/data/ec-prime-logo.svg';

const HelpDialogTraning5 = (props) => {
    return(
        <React.Fragment>
            画面下部の「終了する」をタップしてトレーニングを終えてください。<br />
            <br />
        </React.Fragment>
    );
}

export { HelpDialogTraning5 };
